<ng-template #template let-i>
  <ng-container [formGroup]="i">
    <div>
      <input formControlName="id" type="hidden" />

      <pr-input label="Type" [derrors]="derrors">
        <mat-select formControlName="type">
          @for (type of estateTypes; track type) {
            <mat-option [value]="type.id">
              {{ type.value | translate }}
            </mat-option>
          }
        </mat-select>
      </pr-input>

      <pr-input label="Fréquence" [derrors]="derrors">
        <mat-select formControlName="frequency">
          @for (periodicityType of periodicityTypes; track periodicityType) {
            <mat-option [value]="periodicityType.id">
              {{ periodicityType.value | translate }}
            </mat-option>
          }
        </mat-select>
      </pr-input>

      <pr-input [label]="'Montant'" [suffix]="'€'" [derrors]="derrors"
        ><input formControlName="amount" type="text"
      /></pr-input>

      <pr-input-date
        formControlName="startDate"
        label="Date de 1er paiement"
        [derrors]="derrors"
      ></pr-input-date>

      <pr-input-radio
        formControlName="isCurrent"
        label="Frais récurrents"
        toggleBgEmpty="true"
      ></pr-input-radio>

      <pr-input-date
        formControlName="endDate"
        label="Date de fin"
        [hidden]="i.get('isCurrent').value"
        [derrors]="derrors"
      ></pr-input-date>
    </div>
  </ng-container>
</ng-template>

<!-- <ng-container *ngTemplateOutlet="template"></ng-container> -->

<div [formGroup]="form">
  <ul formArrayName="fees">
    <pr-form-list-item
      *ngFor="let item of fees.controls as FormGroup; let i = index"
      [formGroup]="item"
      [index]="i"
      [context]="this"
      headerClass="horizontal-title-list-item"
      buttonIconVbWidth="23"
      buttonIconVbHeight="23"
      buttonStyle="label"
      buttonClass="btn-nostyle neutral btn-list-remove"
      itemName="cette charge"
      [derrors]="derrors"
      (onDelete)="onDelete($event)"
      (onValidate)="validate(item)"
    >
      @if (item.get('amount').value) {
        <div class="pr-form-list-title-primary">
          {{ getFeesType(item.get('type').value) | translate }}
        </div>
        <div>
          {{ item.get('amount').value | currency: 'EUR' : 'symbol' : '.0-0' }}
        </div>
        @if (
          item.get('startDate').value &&
          item.get('startDate').status === 'VALID'
        ) {
          <div class="pr-form-list-title-tertiary">
            {{ getPeriodicityType(item.get('frequency').value) | translate }}
          </div>
        }
      } @else {
        <div class="pr-form-list-title-primary">Nouveau montant</div>
      }
      <ng-container
        item
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ $implicit: item }"
      ></ng-container>
    </pr-form-list-item>
    @if (derrors && form.controls.errors) {
      <ul class="pr-form-list-errors">
        @if (form.controls.errors) {
          <li>Vous devez declarer au moins un montant</li>
        }
      </ul>
    }
    <div class="pr-form-list-add">
      <pr-button
        clazz="btn-list-add neutral"
        label="Ajouter une charge"
        rightIcon="sp-plus"
        (onClick)="eaFeesFormService.addFees(entity, form.controls)"
      >
      </pr-button>
    </div>
  </ul>
</div>
